export default {
  label: 'Campanhas',
  placeholder: 'Todas',
  items: {
    all: 'Todas',
    onlyScheduled: 'Somente Agendadas',
  },
};
